import React, { FC, useMemo } from 'react';
import NavTab from '../nav-tab';
import Styled from './style';
import { useUtils } from '../../core/hooks/useUtils';
import { logoutAction } from '../../store/Auth/action';
import RoundImg from '../avatar';
import { Typography } from '../typography';
import logout from '../../assets/images/logout.png';

type IProps = {
	width: number;
};

const SideBar: FC<IProps> = ({ width }) => {
	const {
		dispatch,
		store: { user },
	} = useUtils();
	const { avatar, firstName, lastName, team } = user.data;
	const fullName = `${firstName || ''} ${lastName || ''}`;

	const logOut = () => {
		dispatch(logoutAction());
	};

	const tabs = useMemo(
		() => [
			{
				title: 'My boards',
				link: '/my-boards',
				img: 'home',
			},

			{
				title: 'Ask',
				link: '/ask',
				img: 'discover',
			},
			{
				title: 'Team rooms',
				link: '/team-rooms',
				img: 'team',
			},
		],
		[]
	);

	return (
		<Styled.Content width={width}>
			<Styled.Block>
				<Styled.Center>
					<Styled.Logo />
				</Styled.Center>
			</Styled.Block>
			<Styled.Block style={{ width: '100%' }}>
				{tabs.map((tab, i) => (
					<NavTab key={i} {...tab} />
				))}
			</Styled.Block>
			<Styled.Block style={{ width: '100%' }}>
				<Styled.ProfileWrapper style={{ marginBottom: 20 }}>
					<Styled.Avatar>
						<RoundImg
							avatar={avatar}
							size={50}
							name={fullName}
							isBorder
							isShadow
						/>
					</Styled.Avatar>
					<Styled.Info>
						<Typography text={fullName} size="large" type="bold" />
						<Typography text={team?.name} size="normal" />
					</Styled.Info>
				</Styled.ProfileWrapper>
				<NavTab title="Settings" link="/settings" img="settings" />
				<Styled.Line />
				<Styled.ProfileWrapper>
					<Styled.Center>
						<Styled.Button onClick={logOut}>
							<img src={logout} style={{ width: 20, marginLeft: 2 }} alt="" />
						</Styled.Button>
					</Styled.Center>
					<Typography text="Log out" size="normal" />
				</Styled.ProfileWrapper>
			</Styled.Block>
		</Styled.Content>
	);
};

export default SideBar;
